module.exports = __webpack_public_path__ + "79e1f9a3559fb4bb3455c83623beea3b.png";